namespace $.$$ {

	$mol_style_define( $shm_wordstat_dashboard, {
		width: '100%',
		minHeight: '100%',

		Collect_page: {
			minWidth: '520px',
			flex: {
				grow: 0,
				shrink: 1,
				basis: '520px',
			},
			Head: {
				align: {
					items: 'center',
				},
			},
			Title: {
				gap: 0,
				padding: 0,
				minHeight: 0,
				minWidth: 0,
				overflow: 'hidden',
			},
			Tools: {
				align: {
					items: 'center',
				},
			},
		},

		Collects_page: {
			flex: {
				grow: 1,
				shrink: 1,
				basis: '720px',
			},
			width: 'auto',
			minWidth: '18rem',
			Title: {
				align: {
					items: 'center',
				},
				gap: 0,
				padding: 0,
				minWidth: 0,
				overflow: 'hidden',
			},
		},

		Collects_title: {
			display: 'block',
			align: {
				items: 'center',
			},
			padding: $mol_gap.text,
			minWidth: 0,
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			flex: {
				grow: 1,
				shrink: 1,
				basis: 'auto',
			},
		},

		Collects_quota: {
			// Ellipsis applies to a block's inline text, not an anonymous flex item.
			display: 'block',
			color: $mol_theme.shade,
			align: {
				items: 'center',
			},
			padding: $mol_gap.text,
			minWidth: 0,
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			flex: {
				grow: 0,
				shrink: 100,
				basis: 'auto',
			},
		},

		Report_page: {
			flex: {
				grow: 1,
				shrink: 1,
				basis: '720px',
			},
			minWidth: '520px',
			Head: {
				align: {
					items: 'center',
				},
			},
			Title: {
				gap: 0,
				padding: 0,
				minHeight: 0,
				minWidth: 0,
				overflow: 'hidden',
			},
			Tools: {
				align: {
					items: 'center',
				},
			},
		},

		Filters_page: {
			width: '400px',
			minWidth: '300px',
		},

		Result_panel: {
			padding: $mol_gap.block,
			gap: $mol_gap.block,
			flex: {
				direction: 'column',
				grow: 1,
				shrink: 1,
			},
			minWidth: 0,
			minHeight: 0,
		},

		Empty: {
			color: $mol_theme.shade,
			padding: $mol_gap.block,
		},

		Collect_error: {
			color: $shm_theme.error,
			padding: $mol_gap.block,
		},

		Report_error: {
			color: $shm_theme.error,
			padding: {
				left: $mol_gap.block,
				right: $mol_gap.block,
				bottom: $mol_gap.block,
			},
		},

		Collect_regular_row: {
			align: {
				items: 'center',
			},
			gap: $mol_gap.text,
			flex: {
				wrap: 'wrap',
			},
			padding: {
				left: $mol_gap.block,
				right: $mol_gap.block,
				top: $mol_gap.block,
			},
		},

		Collect_regular_hint: {
			color: $mol_theme.shade,
		},

		Collect_regular: {
			minWidth: 0,
			maxWidth: '100%',
			whiteSpace: 'normal',
		},

		Reports_row: {
			align: {
				items: 'flex-end',
			},
			gap: $mol_gap.block,
			flex: {
				wrap: 'wrap',
			},
			padding: $mol_gap.block,
			border: {
				top: {
					width: '1px',
					style: 'solid',
					color: $mol_theme.line,
				},
			},
		},

		Reports_actions: {
			flex: {
				direction: 'column',
			},
			align: {
				items: 'flex-start',
			},
			gap: $mol_gap.text,
		},

		Telegram_chat_ids_label: {
			flex: {
				grow: 1,
				basis: '12rem',
			},
		},

		Max_chat_ids_label: {
			flex: {
				grow: 1,
				basis: '12rem',
			},
		},

	} )

}
